import { useEffect, useState } from 'react'
import { souSouWallet } from 'apiv2'

const isItem = item => !!item && typeof item === 'object' && typeof item.circleId === 'string' && item.circleId !== '' && typeof item.name === 'string'

// Sou-Sou items for the wallet grid. Any failure (network, 401/403, malformed body) leaves the list empty:
// the existing wallet must never be affected by this request.
const useSouSouWallet = ({ enabled, eventType, search, sort }) => {
  const [result, setResult] = useState({ eventType: '', items: [] })

  useEffect(() => {
    if (!enabled) return undefined
    let active = true
    // list() reads the token synchronously, so it is called inside a promise to turn a throw into a rejection
    Promise.resolve()
      .then(() => souSouWallet.list({ eventType, sort, search }))
      .then(response => {
        const items = response?.data?.items
        if (active) setResult({ eventType, items: Array.isArray(items) ? items.filter(isItem) : [] })
      })
      .catch(() => {
        if (active) setResult({ eventType, items: [] })
      })
    return () => { active = false }
  }, [enabled, eventType, search, sort])

  // a list that belongs to the other tab (Active/Archive) is never shown; during a new search the previous list stays until the answer
  return enabled && result.eventType === eventType ? result.items : []
}

export default useSouSouWallet
